import classes from './password-input.module.css'

const PasswordInput = {
  classNames: {
    root: classes.root,
  },
}

export default PasswordInput
